import { render, staticRenderFns } from "./MapCollectionsPage.vue?vue&type=template&id=e38ea6be&scoped=true&"
import script from "./MapCollectionsPage.vue?vue&type=script&lang=js&"
export * from "./MapCollectionsPage.vue?vue&type=script&lang=js&"
import style0 from "./MapCollectionsPage.vue?vue&type=style&index=0&id=e38ea6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ea6be",
  null
  
)

export default component.exports